import { V2ExpertiseAndResources } from "src/pages/reports/fsci/v2/types";

export const meta: Record<V2ExpertiseAndResources, Opportunity> = {
    qualifiedStaff: {
        title: "Qualified Staff",
        prologue: "New teacher hires are credentialed (licensed/certified) and have classroom experience.",
    },
    resourceConstraint: {
        title: "Resource Constraints",
        prologue:
            "The school has financial resources to operate effectively; or, we could be more effective as a school if not for fiscal constraints, and we lack the resources we need to make changes in our school.",
        extra: "* A high score indicates that respondents generally disagreed that additional resources would improve administrative or operational effectiveness and agreed that they have sufficient resources to implement necessary changes.",
    },
    resourcePlanning: {
        title: "Resource Planning",
        prologue:
            "A strategic financial plan and master facilities plan is in place, and financial planning is a strength of the board.",
    },
    resources: {
        title: "Resources",
        prologue:
            "Materials and resources for teaching, including technology, are sufficient, and the school building is in good physical condition.",
    },
    responsivenessToSpecialNeeds: {
        title: "Responsiveness to Special Needs",
        prologue:
            "Teaching staff works together to serve students with special needs, aided by processes and resources for identifying and responding to those needs.",
    },
};
